
import * as constants from "../constants.js";
import notifications from "../notifications.js";


export default {
    OnSuccess(description) {
        notifications.Success("Pontos de Venda", description);
    },

    OnWarning(resp, description) {
        notifications.Warning("Pontos de Venda", description);
        console.log(resp);
    },

    OnError(resp, description) {
        notifications.Error("Pontos de Venda", description);
        console.log(resp);
    },

    OnUnauthorized() {
        window.location.reload();
    },

    SearchAdvertiserLocations: async function (idPublic,size, num,) {
        let reqUri = `${constants.API_ENDPOINT_LOCATIONS}/${idPublic}/search/${size}/${num}`;

        let result = await fetch(`${reqUri}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao pesquisar os Pontos de Venda");
                        return null;
                    }
                    if (resp.status == 401) {
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    
    GetContacto: async function (idPublic, advert) {
        let reqUri = `${constants.API_ENDPOINT_LOCATIONS}/${idPublic}/contacto?advert=${advert}`;

        let result = await fetch(`${reqUri}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(async resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao pesquisar o Ponto de Venda");
                        return null;
                    }
                    if (resp.status == 401) {
                        this.OnUnauthorized();
                        return null;
                    }
                    if (resp.status == 429) {
                        var result = await resp.json();
                        if (result != null && result.Errors){
                            var error = result.Errors[0];
                            this.OnWarning(result, error.Message);
                        }
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    
    PostClickPhone: async function (idPublic, advert) {
        let reqUri = `${constants.API_ENDPOINT_LOCATIONS}/${idPublic}/phone?advert=${advert}`;

        let result = await fetch(`${reqUri}`, {
            method: constants.HTTP_METHOD_POST
        })
            .then(async resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        console.log("Ocorreu uma anomalia ao pesquisar o Ponto de Venda");
                        console.log(resp);
                        return null;
                    }
                    if (resp.status == 401) {
                        this.OnUnauthorized();
                        return null;
                    }
                    if (resp.status == 429) {
                        var result = await resp.json();
                        if (result != null && result.Errors){
                            var error = result.Errors[0];
                            console.log(result);
                            console.log(error.Message);
                        }
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    
    // GetAdvertiserMainLocation: async function (idPublic) {
    //     let reqUri = `${constants.API_ENDPOINT_LOCATIONS}/${idPublic}/main`;

    //     let result = await fetch(`${reqUri}`, {
    //         method: constants.HTTP_METHOD_GET
    //     })
    //         .then(resp => {
    //             if (!resp.ok) {
    //                 if (resp.status >= 500) {
    //                     this.OnError(resp, "Ocorreu uma anomalia ao pesquisar o Ponto de Venda Principal");
    //                     return null;
    //                 }
    //                 if (resp.status == 401) {
    //                     this.OnUnauthorized();
    //                     return null;
    //                 }
    //             }

    //             return resp.json();
    //         });

    //     return result;
    // },
}